import { KeyedObject } from "types/root";
import { fetchService } from "utils/fetch";
import { ProjectsFilter } from 'types/project';


/*
export async function fetchServerSearch(kwargs: StringIndexedObject) {

	await get(`${API_URLS.search}?term=${kwargs.searchTerm}`)
	.then(response => {
		if (response.ok) {
		  return response.json();
		}
		throw new Error(`HTTP error! status: ${response.status}`);
	})
	.then(data => {
		kwargs.callback(data)
	})
	.catch(error => {
	})
	.finally(() => {
	})
};

export async function fetchProjectUsers(kwargs: StringIndexedObject) {

	await get(`${API_URLS.getProjectMembers}`)
	.then(response => {
		if (response.ok) {
		  return response.json();
		}
		throw new Error(`HTTP error! status: ${response.status}`);
	})
	.then(data => {
		kwargs.callback(data)
	})
	.catch(error => {
	})
	.finally(() => {
	})
};
*/

export async function doGetReq(kwargs: KeyedObject) {
    const url = kwargs.url;
    const params = kwargs.params;
    const callback = kwargs.callback;
    
    await fetchService.get(url, params).then(response => {
    if (!response.ok) {
        callback({}, response.status)
        throw new Error(`HTTP error! status: ${response.status}`);
    }
        return response.json();
    })
    .then(data => {
        callback(data)
    })
    .catch(error => {
        console.error(error)
        callback({success: false, message: error.message})
    });

}

export async function doPostReq(kwargs: KeyedObject) {
    const url = kwargs.url;
    const params = kwargs.params;
    const callback = kwargs.callback;
    
    await fetchService.post(url, params).then(response => {
    if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
    }
        return response.json();
    })
    .then(data => {
        callback(data)
    })
    .catch(error => {
        console.error(error)
        callback({success: false, message: error.message})
    });

}

export async function doPutReq(kwargs: KeyedObject) {
    const url = kwargs.url;
    const params = kwargs.params;
    const callback = kwargs.callback;
    
    await fetchService.put(url, params).then(response => {
    if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
    }
        return response.json();
    })
    .then(data => {
        callback(data)
    })
    .catch(error => {
        console.error(error)
        callback({success: false, message: error.message})
    });

}

export async function doPostFDReq(kwargs: KeyedObject) {
    const url = kwargs.url;
    const params = kwargs.params;
    const files = kwargs.files;
    const callback = kwargs.callback;
    
    await fetchService.postFD(url, params, files).then(response => {
    if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
    }
        return response.json();
    })
    .then(data => {
        callback(data)
    })
    .catch(error => {
        console.error(error)
        callback({success: false, message: error.message})
    });

}

export async function doPutFDReq(kwargs: KeyedObject) {
    const url = kwargs.url;
    const params = kwargs.params;
    const files = kwargs.files;
    const callback = kwargs.callback;
    
    await fetchService.putFD(url, params, files).then(response => {
    if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
    }
        return response.json();
    })
    .then(data => {
        callback(data)
    })
    .catch(error => {
        console.error(error)
        callback({success: false, message: error.message})
    });

}

export async function filterProjects(filter: ProjectsFilter) {
  return {}
  // NOT YET IMPLEMENTED
  // return await axios.post('/api/products/filter', { filter });
}
